// Servizi dominio RESTAURANT (menu, prenotazioni, tavoli/sala, camerieri, rider, vini,
// pagamenti, QR, servizio, messaggi, reclami, email, logistica, moduli, impostazioni)
// + portale ospite e vetrina pubblica. Riusa l'istanza axios centrale (lib/api.js).
import { api, unwrap } from './client';

const g = (path, params, config) => unwrap(api.get(path, { params, ...(config || {}) }));
const p = (path, body, config) => unwrap(api.post(path, body, config));
const u = (path, body, config) => unwrap(api.put(path, body, config));
const pt = (path, body, config) => unwrap(api.patch(path, body, config));
const d = (path, config) => unwrap(api.delete(path, config));

export const restaurantService = {
  // --- Panoramica / moduli / impostazioni ---
  overview: () => g('/restaurant/overview'),
  getSettings: () => g('/restaurant/settings'),
  updateSettings: (body) => u('/restaurant/settings', body),
  updateLanding: (body) => u('/restaurant/settings/landing', body),
  modules: () => g('/restaurant/modules'),
  modulesAudit: (params) => g('/restaurant/modules/audit', params),
  updateModulesConfig: (body) => u('/restaurant/modules/config', body),
  toggleModule: (body) => u('/restaurant/modules/toggle', body),
  updateRetention: (body) => u('/restaurant/modules/retention', body),
  runRetention: (body) => p('/restaurant/modules/retention/run', body),

  // --- Menu ---
  menuConfig: () => g('/restaurant/menu/config'),
  updateMenuConfig: (body) => u('/restaurant/menu/config', body),
  listCategories: (params) => g('/restaurant/menu/categories', params),
  createCategory: (body) => p('/restaurant/menu/categories', body),
  updateCategory: (id, body) => u(`/restaurant/menu/categories/${id}`, body),
  deleteCategory: (id) => d(`/restaurant/menu/categories/${id}`),
  reorderCategories: (body) => p('/restaurant/menu/categories/reorder', body),
  listItems: (params) => g('/restaurant/menu/items', params),
  createItem: (body) => p('/restaurant/menu/items', body),
  updateItem: (id, body) => u(`/restaurant/menu/items/${id}`, body),
  deleteItem: (id) => d(`/restaurant/menu/items/${id}`),
  duplicateItem: (id) => p(`/restaurant/menu/items/${id}/duplicate`),
  listAllergens: () => g('/restaurant/menu/allergens'),
  createAllergen: (body) => p('/restaurant/menu/allergens', body),
  updateAllergen: (id, body) => u(`/restaurant/menu/allergens/${id}`, body),
  deleteAllergen: (id) => d(`/restaurant/menu/allergens/${id}`),
  listAyceFormulas: () => g('/restaurant/menu/ayce-formulas'),
  createAyceFormula: (body) => p('/restaurant/menu/ayce-formulas', body),
  updateAyceFormula: (id, body) => u(`/restaurant/menu/ayce-formulas/${id}`, body),
  deleteAyceFormula: (id) => d(`/restaurant/menu/ayce-formulas/${id}`),
  priceQuote: (body) => p('/restaurant/menu/price-quote', body),
  translateMenu: (body) => p('/restaurant/menu/translate', body),
  translateMenuMissing: (body) => p('/restaurant/menu/translate/missing', body),

  // --- Prenotazioni ---
  reservations: (params) => g('/restaurant/reservations', params),
  reservationsList: (params) => g('/restaurant/reservations/list', params),
  reservationsStats: (params) => g('/restaurant/reservations/stats', params),
  createReservation: (body) => p('/restaurant/reservations', body),
  createReservationForm: (body) => p('/restaurant/reservations/create', body),
  getReservation: (id) => g(`/restaurant/reservations/item/${id}`),
  updateReservation: (id, body) => u(`/restaurant/reservations/item/${id}`, body),
  reservationIcs: (id, config) => g(`/restaurant/reservations/item/${id}/ics`, undefined, config),
  reservationAction: (id, body) => p(`/restaurant/reservations/item/${id}/action`, body),
  assignReservationTable: (id, body) => p(`/restaurant/reservations/item/${id}/assign-table`, body),
  reservationDeposit: (id, body) => p(`/restaurant/reservations/item/${id}/deposit`, body),
  redeemTheFork: (id) => p(`/restaurant/reservations/item/${id}/thefork/redeem`, {}),
  redeemTheForkByToken: (token) => p('/restaurant/reservations/thefork/redeem-by-token', { token }),
  rescheduleReservation: (id, body) => p(`/restaurant/reservations/item/${id}/reschedule`, body),

  // --- Configurazione prenotazioni ---
  bookingConfig: () => g('/restaurant/booking-config'),
  updateBookingConfig: (body) => u('/restaurant/booking-config', body),
  bookingSlots: (params) => g('/restaurant/booking-config/slots', params),
  createBookingException: (body) => p('/restaurant/booking-config/exceptions', body),
  deleteBookingException: (id) => d(`/restaurant/booking-config/exceptions/${id}`),

  // --- Sala: tavoli e stanze ---
  listTables: (params) => g('/restaurant/tables', params),
  createTable: (body) => p('/restaurant/tables', body),
  updateTable: (id, body) => u(`/restaurant/tables/${id}`, body),
  deleteTable: (id) => d(`/restaurant/tables/${id}`),
  updateTablePosition: (id, body) => u(`/restaurant/tables/${id}/position`, body),
  tableHistory: (id) => g(`/restaurant/tables/${id}/history`),
  activateTable: (id) => p(`/restaurant/tables/${id}/activate`),
  deactivateTable: (id) => p(`/restaurant/tables/${id}/deactivate`),
  assignTable: (id, body) => p(`/restaurant/tables/${id}/assign`, body),
  freeTable: (id) => p(`/restaurant/tables/${id}/free`),
  occupyTable: (id, body) => p(`/restaurant/tables/${id}/occupy`, body),
  seatTable: (id, body) => p(`/restaurant/tables/${id}/seat`, body),
  requestBill: (id) => p(`/restaurant/tables/${id}/request-bill`),
  tableSession: (id, body) => p(`/restaurant/tables/${id}/session`, body),
  waiterCall: (id, body) => p(`/restaurant/tables/${id}/waiter-call`, body),
  listRooms: () => g('/restaurant/rooms'),
  createRoom: (body) => p('/restaurant/rooms', body),
  updateRoom: (id, body) => u(`/restaurant/rooms/${id}`, body),
  deleteRoom: (id) => d(`/restaurant/rooms/${id}`),

  // --- Camerieri ---
  listWaiters: (params) => g('/restaurant/waiters', params),
  createWaiter: (body) => p('/restaurant/waiters', body),
  updateWaiter: (id, body) => u(`/restaurant/waiters/${id}`, body),
  deleteWaiter: (id) => d(`/restaurant/waiters/${id}`),
  waiterAudit: (id) => g(`/restaurant/waiters/${id}/audit`),
  resetWaiterPin: (id) => p(`/restaurant/waiters/${id}/reset-pin`),
  /** Azione generica su cameriere (activate/deactivate/revoke-sessions/archive). */
  waiterAction: (id, action, body) => p(`/restaurant/waiters/${id}/${action}`, body),

  // --- Rider ---
  listRiders: (params) => g('/restaurant/riders', params),
  createRider: (body) => p('/restaurant/riders', body),
  updateRider: (id, body) => u(`/restaurant/riders/${id}`, body),
  deleteRider: (id) => d(`/restaurant/riders/${id}`),
  riderAudit: (id) => g(`/restaurant/riders/${id}/audit`),
  resetRiderPin: (id) => p(`/restaurant/riders/${id}/reset-pin`),
  /** Azione generica su rider (activate/deactivate/revoke-sessions/archive). */
  riderAction: (id, action, body) => p(`/restaurant/riders/${id}/${action}`, body),

  // --- Vini ---
  listWineCategories: (params) => g('/restaurant/wine/categories', params),
  createWineCategory: (body) => p('/restaurant/wine/categories', body),
  updateWineCategory: (id, body) => u(`/restaurant/wine/categories/${id}`, body),
  deleteWineCategory: (id) => d(`/restaurant/wine/categories/${id}`),
  reorderWineCategories: (body) => p('/restaurant/wine/categories/reorder', body),
  listWineries: () => g('/restaurant/wine/wineries'),
  createWinery: (body) => p('/restaurant/wine/wineries', body),
  updateWinery: (id, body) => u(`/restaurant/wine/wineries/${id}`, body),
  deleteWinery: (id) => d(`/restaurant/wine/wineries/${id}`),
  listWines: (params) => g('/restaurant/wine/wines', params),
  createWine: (body) => p('/restaurant/wine/wines', body),
  updateWine: (id, body) => u(`/restaurant/wine/wines/${id}`, body),
  deleteWine: (id) => d(`/restaurant/wine/wines/${id}`),
  wineDishes: () => g('/restaurant/wine/dishes'),
  translateWine: (body) => p('/restaurant/wine/translate', body),
  translateWineMissing: (body) => p('/restaurant/wine/translate/missing', body),

  // --- Pagamenti ---
  paymentsConfig: () => g('/restaurant/payments/config'),
  updatePaymentsConfig: (body) => u('/restaurant/payments/config', body),
  verifyPaymentsConfig: (body) => p('/restaurant/payments/config/verify', body),
  paymentsDashboard: (params) => g('/restaurant/payments/dashboard', params),
  listDeposits: (params) => g('/restaurant/payments/deposits', params),
  depositAction: (body) => p('/restaurant/payments/deposits/action', body),
  listTransactions: (params) => g('/restaurant/payments/transactions', params),
  transactionReceipt: (id, config) => g(`/restaurant/payments/transactions/${id}/receipt.pdf`, undefined, config),
  assignTransactionWaiter: (id, body) => p(`/restaurant/payments/transactions/${id}/assign-waiter`, body),
  collectCash: (id, body) => p(`/restaurant/payments/transactions/${id}/collect-cash`, body),
  paymentsReport: (params) => g('/restaurant/payments/report', params),
  paymentsExport: (params, config) => g('/restaurant/payments/export', params, config),
  listTips: (params) => g('/restaurant/payments/tips', params),
  tipsLeaderboard: (params) => g('/restaurant/payments/tips/leaderboard', params),
  tipsShifts: (params) => g('/restaurant/payments/tips/shifts', params),
  closeTipsShift: (body) => p('/restaurant/payments/tips/close-shift', body),
  manualPayment: (body) => p('/restaurant/payments/manual', body),
  paymentRefund: (body) => p('/restaurant/payments/refunds', body),

  // --- QR ---
  qrOverview: () => g('/restaurant/qr/overview'),
  listQrCodes: (params) => g('/restaurant/qr/codes', params),
  createQrCode: (body) => p('/restaurant/qr/codes', body),
  bulkQrCodes: (body) => p('/restaurant/qr/codes/bulk', body),
  updateQrCode: (id, body) => pt(`/restaurant/qr/codes/${id}`, body),
  deleteQrCode: (id) => d(`/restaurant/qr/codes/${id}`),
  endQrSession: (id) => p(`/restaurant/qr/codes/${id}/end-session`),
  regenerateQrCode: (id) => p(`/restaurant/qr/codes/${id}/regenerate`),
  revokeQrCode: (id) => p(`/restaurant/qr/codes/${id}/revoke`),
  rotateQrCode: (id) => p(`/restaurant/qr/codes/${id}/rotate`),
  toggleQrCode: (id, body) => p(`/restaurant/qr/codes/${id}/toggle`, body),
  verifyQrCode: (id, body) => p(`/restaurant/qr/codes/${id}/verify`, body),
  qrExportPdf: (params, config) => g('/restaurant/qr/export/pdf', params, config),
  qrMenuPreview: (params) => g('/restaurant/qr-menu/preview', params),
  updateQrMenuCustomization: (body) => u('/restaurant/qr-menu/customization', body),

  // --- Servizio (board sala) ---
  serviceBoard: (params) => g('/restaurant/service/board', params),
  serviceConfig: () => g('/restaurant/service/config'),
  updateServiceConfig: (body) => u('/restaurant/service/config', body),
  orderStatus: (id, body) => p(`/restaurant/service/orders/${id}/status`, body),
  resolveServiceRequest: (id, body) => p(`/restaurant/service/requests/${id}/resolve`, body),

  // --- Messaggi ---
  listMessages: (params) => g('/restaurant/messages', params),
  messagesStats: () => g('/restaurant/messages/stats'),
  deleteMessage: (id) => d(`/restaurant/messages/${id}`),
  archiveMessage: (id, body) => p(`/restaurant/messages/${id}/archive`, body),
  readMessage: (id) => p(`/restaurant/messages/${id}/read`),
  replyMessage: (id, body) => p(`/restaurant/messages/${id}/reply`, body),
  readAllMessages: () => p('/restaurant/messages/read-all'),
  digestConfig: () => g('/restaurant/messages/digest-config'),
  updateDigestConfig: (body) => u('/restaurant/messages/digest-config', body),
  runDigestNow: (body) => p('/restaurant/messages/digest/run-now', body),

  // --- Reclami (interni) ---
  listComplaints: (params) => g('/restaurant/complaints', params),
  getComplaint: (id) => g(`/restaurant/complaints/${id}`),
  complaintAttachment: (id, attId, config) => g(`/restaurant/complaints/${id}/attachment/${attId}`, undefined, config),
  addComplaintAttachment: (id, body, config) => p(`/restaurant/complaints/${id}/attachment`, body, config),
  complaintMessage: (id, body) => p(`/restaurant/complaints/${id}/message`, body),
  resolveComplaint: (id, body) => p(`/restaurant/complaints/${id}/resolve`, body),
  complaintsReport: (params) => g('/restaurant/complaints/report', params),
  complaintsExport: (params, config) => g('/restaurant/complaints/export', params, config),
  /** Azione generica su reclamo (path dinamico /complaints/{id}/{action}). */
  complaintAction: (id, action, body) => p(`/restaurant/complaints/${id}/${action}`, body),

  // --- Reclami (pubblici, portale ospite) ---
  getPublicComplaint: (id) => g(`/restaurant/complaints-public/${id}`),
  publicComplaintAttachment: (id, attId, config) => g(`/restaurant/complaints-public/${id}/attachment/${attId}`, undefined, config),
  addPublicComplaintAttachment: (id, body, config) => p(`/restaurant/complaints-public/${id}/attachment`, body, config),
  publicComplaintMessage: (id, body) => p(`/restaurant/complaints-public/${id}/message`, body),

  // --- Email ---
  emailProvider: () => g('/restaurant/email/provider'),
  updateEmailProvider: (body) => u('/restaurant/email/provider', body),
  verifyEmailProvider: (body) => p('/restaurant/email/provider/verify', body),
  emailTemplates: (params) => g('/restaurant/email/templates', params),
  getEmailTemplate: (id, params) => g(`/restaurant/email/templates/${id}`, params),
  updateEmailTemplate: (id, body) => u(`/restaurant/email/templates/${id}`, body),
  previewEmailTemplate: (id, body) => p(`/restaurant/email/templates/${id}/preview`, body),
  resetEmailTemplate: (id, body) => p(`/restaurant/email/templates/${id}/reset`, body),
  sendTestEmailTemplate: (id, body) => p(`/restaurant/email/templates/${id}/send-test`, body),
  emailLog: (params) => g('/restaurant/email/log', params),
  emailPlaceholders: () => g('/restaurant/email/placeholders'),

  // --- Logistica / delivery ---
  logisticaDashboard: (params) => g('/restaurant/logistica/dashboard', params),
  logisticaIntegration: () => g('/restaurant/logistica/integration'),
  notifyIntegration: (body) => p('/restaurant/logistica/integration/notify', body),
  regenerateIntegrationKey: () => p('/restaurant/logistica/integration/regenerate-key'),
  listLogisticaOrders: (params) => g('/restaurant/logistica/orders', params),
  createLogisticaOrder: (body) => p('/restaurant/logistica/orders', body),
  getLogisticaOrder: (id) => g(`/restaurant/logistica/orders/${id}`),
  logisticaOrderEvents: (id) => g(`/restaurant/logistica/orders/${id}/events`),
  assignRiderToOrder: (id, body) => p(`/restaurant/logistica/orders/${id}/assign-rider`, body),
  /** Azione generica su ordine logistica (path dinamico /orders/{id}/{action}). */
  logisticaOrderAction: (id, action, body) => p(`/restaurant/logistica/orders/${id}/${action}`, body),
  ingestOrders: (body, config) => p('/restaurant/ingest/orders', body, config),

  // --- Portale ospite (link prenotazione) ---
  getGuest: (id) => g(`/restaurant/guest/${id}`),
  guestAvailability: (id, params) => g(`/restaurant/guest/${id}/availability`, params),
  guestAddGuests: (id, body) => p(`/restaurant/guest/${id}/add-guests`, body),
  guestPayDeposit: (id, body) => p(`/restaurant/guest/${id}/pay-deposit`, body),
  // Caparra con carta reale (Stripe Payment Element, area ospite)
  guestDepositIntent: (id) => p(`/restaurant/guest/${id}/deposit/intent`, {}),
  guestDepositConfirm: (id, orderId) => p(`/restaurant/guest/${id}/deposit/confirm`, { order_id: orderId }),
  guestRequestCancellation: (id, body) => p(`/restaurant/guest/${id}/request-cancellation`, body),
  guestReschedule: (id, body) => p(`/restaurant/guest/${id}/reschedule`, body),

  // --- Vetrina pubblica ---
  publicStructures: (params) => g('/restaurant/public/structures', params),
  publicStructure: (id) => g(`/restaurant/public/structures/${id}`),
  publicMenu: (id, params) => g(`/restaurant/public/structures/${id}/menu`, params),
  publicAvailability: (id, params) => g(`/restaurant/public/structures/${id}/availability`, params),
  publicReservation: (id, body) => p(`/restaurant/public/structures/${id}/reservation`, body),

  // --- Recensioni (#11) ---
  listReviews: () => g('/restaurant/reviews'),
  replyReview: (id, reply) => p(`/restaurant/reviews/${id}/reply`, { reply }),
  publicReviews: (id) => g(`/restaurant/public/structures/${id}/reviews`),
  publicSubmitReview: (id, body) => p(`/restaurant/public/structures/${id}/reviews`, body),
};
